var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgColon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 5,
  height: 53,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.15 9.315v8.703",
  stroke: "#534E46",
  strokeWidth: 0.163
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.15 20.92.099 22.97l2.051 2.052 2.051-2.051-2.051-2.052Zm0 7.003L.099 29.974l2.051 2.052 2.051-2.052-2.051-2.051Z",
  fill: "#5758FF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.15 34.927v8.703",
  stroke: "#534E46",
  strokeWidth: 0.163
})));
export { SvgColon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI1MyIgdmlld0JveD0iMCAwIDUgNTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjE0OTkgOS4zMTQ5NFYxOC4wMTgyIiBzdHJva2U9IiM1MzRFNDYiIHN0cm9rZS13aWR0aD0iMC4xNjMxODciLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjE1MDAyIDIwLjkxOTNMMC4wOTg2MzI4IDIyLjk3MDdMMi4xNTAwMiAyNS4wMjIxTDQuMjAxNCAyMi45NzA3TDIuMTUwMDIgMjAuOTE5M1pNMi4xNTAwMiAyNy45MjI5TDAuMDk4NjMyOCAyOS45NzQzTDIuMTUwMDIgMzIuMDI1N0w0LjIwMTQgMjkuOTc0M0wyLjE1MDAyIDI3LjkyMjlaIiBmaWxsPSIjNTc1OEZGIi8+CjxwYXRoIGQ9Ik0yLjE0OTkgMzQuOTI2OFY0My42MyIgc3Ryb2tlPSIjNTM0RTQ2IiBzdHJva2Utd2lkdGg9IjAuMTYzMTg3Ii8+Cjwvc3ZnPgo=";